// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__vazuB","notes":"Notes_notes__36VlS","note":"Notes_note__1Mwoa","markdown":"Notes_markdown__3ZFiF"};